<section class="banner text-white">
  <div class="container">
    <div class="row justify-content-md-center text-center text-white">
      <div class="col-lg-10" data-aos="fade-up">
        <div class="name">You Are Invited By : {{ userName }}</div>
      </div>
    </div>

    <div class="row my-4">
      <div class="col-lg-8 offset-lg-2 top-area" data-aos="zoom-in">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-4">
            <div class="logo">
              <a href="#"
                ><img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation22/images/logo.png"
                  alt="logo"
                  class="img-fluid"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-6 sign-area">
            <!-- <a class="btn btn-sign" routerLink="/login" role="button">Sign In </a> / -->

            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-sign go"
              role="button"
              >Sign Up
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-10 text-center">
        <h1 data-aos="zoom-in-up" data-aos-duration="300">
          The Ultimate Marketing
        </h1>
        <h5 data-aos="zoom-in-up" data-aos-duration="800">
          Paradigm shifting platform!
        </h5>
        <p data-aos="zoom-in-up" data-aos-duration="1200">
          The internet marketing gurus have meticulously developed a marketing
          solution that will mark a milestone in the history of digital
          commerce. Shift your focus towards growth and succeed in life!
        </p>
      </div>
    </div>

    <div
      class="row justify-content-md-center mt-3"
      data-aos="flip-up"
      data-aos-duration="1000"
    >
      <div class="col-lg-6 text-center">
        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'regform'"
          class="btn btn-outline-primary"
          role="button"
          >Register Here!</a
        >
      </div>
    </div>
  </div>
</section>
<section class="sec_fast">
  <div class="container">
    <div class="row">
      <input
        type="hidden"
        id="ipadress"
        name="ipadress"
        value="14.97.11.70, 192.180.10.18"
      />
      <input
        type="hidden"
        id="key"
        name="key"
        value="56e0d8aaef9f0c485ac454467477cbd3"
      />
      <div
        class="col-lg-12"
        data-aos="zoom-in-left"
        data-aos-easing="linear"
        data-aos-duration="1500"
      >
        Now Open in <span id="city">{{ city }}</span
        >, <span id="country">{{ country }}</span> <br />
        <span class="right_text_main"
          >Worldwide Priority Placement Available</span
        >
      </div>
    </div>
  </div>
</section>
<section class="sec_two">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="play_button">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation20/images/play-button.png"
            class="img-fluid"
            alt="image"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal1"
          />
        </div>

        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-10-a.png"
          alt=""
          class="img-fluid vedio-one-a"
          data-aos="flip-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        />
        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-1-b.png"
          alt=""
          class="img-fluid vedio-one-b"
          data-aos="flip-right"
          data-aos-easing="linear"
          data-aos-duration="1000"
        />
      </div>
      <div class="col-lg-6 right-1">
        <h2 data-aos="zoom-out-left">Be the change you seek!</h2>
        <p data-aos="zoom-out-left">
          This unparallel business space is powerful enough to transform your
          income scenario completely. Affiliate marketers are using this system
          to build their own businesses while adding value to the world.
        </p>

        <p data-aos="zoom-out-left">
          Designed with experience of over 20 years, the system can add
          extraordinary dynamics and help you recover from all monetary
          misbalance. A lot can happen within a year!
        </p>

        <div class="row">
          <div class="col-lg-8 text-center" data-aos="zoom-out-left">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-outline-primary-2 w-100"
              role="button"
              >Register Here!</a
            >
          </div>
        </div>

        <img
          src="{{ myLinksS3URL }}frontend/presentation20/images/sec-bg-shap.png"
          alt=""
          class="img-fluid grap-bg-1"
        />
      </div>
    </div>
  </div>
</section>

<section class="sec_three">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-6 right order-md-2">
        <div class="play_button">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation20/images/play-button.png"
            class="img-fluid"
            alt="image"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal2"
          />
        </div>

        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-2-a.png"
          alt=""
          class="img-fluid vedio-two-a"
          data-aos="flip-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        />
        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-2-b.png"
          alt=""
          class="img-fluid vedio-two-b"
          data-aos="flip-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        />
      </div>

      <div class="col-lg-6 order-md-1 mt-3">
        <div class="title-1" data-aos="zoom-out-right">
          Be courageous and accept the risk! We guarantee you 100% money back.
          Sit back and witness the power of internet with:
        </div>

        <ul class="double_column">
          <li data-aos="zoom-out-right">Daily income</li>
          <li data-aos="zoom-out-right">Global visitors</li>
          <li data-aos="zoom-out-right">Automated Recruitment</li>
          <li data-aos="zoom-out-right">Unlimited rotators</li>
        </ul>
        <p data-aos="zoom-out-right">
          The back-office is a very dynamic platform that houses the powerful
          tools used for the O-Founders initiative which is quite simple. Go
          through the video and learn more.
        </p>

        <div class="row">
          <div class="col-lg-8 text-center" data-aos="zoom-out-right">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-outline-primary-2 w-100"
              role="button"
              >Register Here!</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="sec_four">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 right">
        <div class="play_button">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation20/images/play-button.png"
            class="img-fluid"
            alt="image"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal3"
          />
        </div>

        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-3-a.png"
          alt=""
          class="img-fluid vedio-ther-a"
          data-aos="flip-right"
          data-aos-easing="linear"
          data-aos-duration="500"
        />
        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/video-bg-3-b.png"
          alt=""
          class="img-fluid vedio-ther-b"
          data-aos="flip-right"
          data-aos-easing="linear"
          data-aos-duration="500"
        />
      </div>
      <div class="col-lg-6 right-1">
        <h2 data-aos="zoom-out-left">
          You may choose Courage or choose Comfort!
        </h2>
        <p data-aos="zoom-out-left">
          Attend announcements, webinar and tutorials to be an active member.
          Grow your own team and earn commissions. Promotional links are
          designed to help you share the extraordinary idea and let your friends
          and family enjoy the fundamental concept.
        </p>

        <div class="row">
          <div
            class="col-lg-8 text-center"
            data-aos="flip-right"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="btn btn-outline-primary-2 w-100"
              role="button"
              >Register Here!</a
            >
          </div>
        </div>

        <img
          src="{{
            myLinksS3URL
          }}frontend/presentation20/images/ther-bg-shap.png"
          alt=""
          class="img-fluid grap-bg-1"
        />
      </div>
    </div>
  </div>
</section>

<section class="sec_five">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="tex-area-1">
          <h3
            data-aos="flip-left"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            Add life to your dreams with our system!
          </h3>
          <p
            data-aos="flip-left"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            Artificial intelligence is put forth at best to make the system
            work. The correct program, the right platform infrastructure and the
            millennial guidance can bring you success. The business masters have
            perfectly integrated into a complete system.
          </p>
          <h4
            data-aos="flip-left"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            Be brave and believe in your actions!
          </h4>
          <p
            data-aos="flip-left"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            Experience countless benefits of the global business platform. Mr.
            Ash Mufareh and his more than two decades of working experience will
            help your business reach the unimaginable growth.
          </p>
        </div>
        <img
          src="{{ myLinksS3URL }}frontend/presentation20/images/text-shap-1.png"
          alt=""
          class="img-fluid txt-bg-1"
        />
      </div>
      <div class="col-lg-6">
        <h5
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          The system is not easy but it is worth it!
        </h5>
        <h2
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          Choose from the options and be a winner.
        </h2>

        <p
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          We provide you a unique online space where Founders can socially
          interact with other Founders.
        </p>

        <div
          class="bg-light mb-3 p-3"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          Wait for the business to launch and then select a package to become a
          founder if seats are available!
        </div>

        <div
          class="bg-light p-3"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          Request a Founders position NOW for a 90% discounted one-time fee of
          $97 to join the 1% at the top before the entire market joins. HIGHLY
          RECOMMENDED!
        </div>
      </div>
    </div>
  </div>
</section>

<section class="sec_six">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="row align-items-center">
          <div
            class="col-lg-6 right"
            data-aos="flip-left"
            data-aos-easing="linear"
            data-aos-duration="500"
          >
            <div class="text-area-2">
              <h1>
                Register with us <br />
                in 3 easy <br />
                steps:
              </h1>
            </div>
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation20/images/text-shap-2.png"
              alt=""
              class="img-fluid orng-bg"
            />
          </div>
          <div class="col-lg-6">
            <div
              class="media"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="500"
            >
              <div class="align-self-center mr-2 number">1</div>
              <div class="media-body align-self-center">
                <h5 class="mt-0">Put basic details to fill up the form.</h5>
              </div>
            </div>

            <div
              class="media"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="800"
            >
              <div class="align-self-center mr-2 number">2</div>
              <div class="media-body align-self-center">
                <h5 class="mt-0">Choose a favourable payment mood.</h5>
              </div>
            </div>

            <div
              class="media"
              data-aos="fade-left"
              data-aos-easing="linear"
              data-aos-duration="1200"
            >
              <div class="align-self-center mr-2 number">3</div>
              <div class="media-body align-self-center">
                <h5 class="mt-0">Get confirmed as a founder.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="seven-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 text-white">
        <h1
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          WELCOME O-FOUNDERS
        </h1>
        <p
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="800"
        >
          In our Global Team there are real people who want to give you an
          honest hand and help you succeed. Get started now to get more details
          inside. Don't miss out. Get started now in minutes, you'll be glad you
          did.
        </p>

        <p
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="1000"
        >
          Already a Founder?
        </p>

        <div class="row">
          <div
            class="col-lg-8 text-center"
            data-aos="fade-right"
            data-aos-easing="linear"
            data-aos-duration="1200"
          >
            <a
              class="btn btn-outline-primary-3 w-100"
              routerLink="/auth/login"
              role="button"
              target="_blank"
              rel="noopener"
            >
              Sign In
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="right-2"
          data-aos="zoom-in-up"
          data-aos-easing="linear"
          data-aos-duration="1000"
        >
          <div class="text-area-3 text-center">
            <h3>WEBINAR</h3>
            <div class="row justify-content-center">
              <div class="col-lg-12 text-center">
                <a
                  class="btn btn-primary-3 w-100"
                  href="#"
                  data-toggle="modal"
                  data-backdrop="static"
                  data-keyboard="false"
                  data-target="#previous"
                  role="button"
                  ><i class="fas fa-play mr-2"></i> PREVIOUS WEBINAR PLAYBACK</a
                >
              </div>
            </div>
          </div>
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation20/images/text-shap-3.png"
            alt=""
            class="img-fluid web-bg"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="eight-area">
  <div class="container text-center" id="regform">
    <div
      class="row mt-70"
      data-aos="zoom-in-down"
      data-aos-easing="linear"
      data-aos-duration="1000"
    >
      <!--                <img src="images/form-bg.png" alt="" class="img-fluid m-auto">-->

      <div class="col-lg-12">
        <img
          src="{{ myLinksS3URL }}frontend/presentation22/images/logo.png"
          alt="logo"
          class="img-fluid m-auto logo-2"
        />

        <div class="pink-text my-3">REGISTER</div>

        <!-- <div class="alert-success">


                                    <strong>Success!</strong> 

                                </div> -->

        <div class="panel-group cst"></div>

        <div class="col-lg-8 m-auto">
          <form [formGroup]="registerForm">
            <div class="row reg">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    class="log_in_fild form-control"
                    placeholder="First Name"
                    formControlName="firstname"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('required') &&
                      registerForm.controls['firstname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    First Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>

                  <span
                    *ngIf="
                      registerForm.controls['firstname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Last Name"
                    class="log_in_fild form-control"
                    formControlName="lastname"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('required') &&
                      registerForm.controls['lastname'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Last Name Required.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 1, max 50 characters.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlyNumbers'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containOnlySpecialChars'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Only special characters are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveSpaces'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive spaces are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveDots'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dots are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveHyphens'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive dashes are not allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['lastname'].hasError(
                        'containConsecutiveUnderScores'
                      )
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Consecutive underscores are not allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Email Address"
                    class="log_in_fild form-control"
                    formControlName="email"
                    required
                  />

                  <span
                    *ngIf="
                      registerForm.controls['email'].hasError('required') &&
                      registerForm.controls['email'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Email id Required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['email'].hasError('pattern')"
                    class="failed-validation"
                    style="color: red"
                  >
                    Please enter valid email.
                  </span>
                  <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                     class="failed-validation" style="color: red">
                                      Email length sould be less than 100.
                                    </span>-->
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group d-block">
                  <div class="password-block">
                    <input
                      matInput
                      placeholder="Password"
                      formControlName="password"
                      class="log_in_fild form-control"
                      [type]="pwdToggle ? 'text' : 'password'"
                      required
                    />
                    <button
                      type="button"
                      class="password-icon"
                      (click)="pwdToggle = !pwdToggle"
                    >
                      <i
                        class="fal"
                        [ngClass]="{
                          'fa-eye': pwdToggle,
                          'fa-eye-slash': !pwdToggle
                        }"
                      ></i>
                    </button>
                  </div>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('required') &&
                      registerForm.controls['password'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password Required
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['password'].hasError('pattern')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Password should contain minimum 8 Characters and Atleast one
                    Uppercase, One Lowercase, one Number and one Special
                    Characters
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="d-block form-group">
                  <input
                    matInput
                    type="text"
                    placeholder="Phone Number"
                    class="log_in_fild form-control"
                    formControlName="phone"
                    onKeyPress="if(this.value.length==20) return false;"
                    onkeydown="return event.keyCode !== 69"
                    required
                  />
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('required') &&
                      registerForm.controls['phone'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Phone number is required.
                  </span>
                  <span
                    *ngIf="registerForm.controls['phone'].hasError('pattern')"
                    class="failed-validation"
                    style="color: red"
                  >
                    Only numbers are allowed.
                  </span>
                  <span
                    *ngIf="
                      registerForm.controls['phone'].hasError('minlength') ||
                      registerForm.controls['phone'].hasError('maxlength')
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Min 6 and max 20 digits.
                  </span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-block form-group">
                  <select
                    formControlName="country_id"
                    required
                    class="log_in_fild form-control"
                  >
                    <option value="">Select Country</option>
                    <option
                      *ngFor="let country of countriesList"
                      [value]="country.countryId"
                    >
                      {{ country.countryName }}
                    </option>
                  </select>
                  <span
                    *ngIf="
                      registerForm.controls['country_id'].hasError(
                        'required'
                      ) && registerForm.controls['country_id'].touched
                    "
                    class="failed-validation"
                    style="color: red"
                  >
                    Plese Select Country
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <div class="row no-gutters">
                    <div class="capcha form-control">
                      <img [src]="imageCaptcha" style="width: 150px" />
                    </div>

                    <div class="refresh-icn">
                      <i
                        class="fa fa-refresh fa-lg"
                        aria-hidden="true"
                        (click)="regenerateCaptcha()"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="main input-effect">
                    <input
                      id="capcha"
                      maxlength="5"
                      name="capcha"
                      type="text"
                      formControlName="enteredCaptcha"
                      placeholder=" Enter Captcha"
                      class="form-control effect-19"
                      required="required"
                    />
                    <span
                      *ngIf="
                        registerForm.controls['enteredCaptcha'].hasError(
                          'required'
                        ) && registerForm.controls['enteredCaptcha'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Captcha Required
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="text-center">
              <button
                mat-raised-button
                type="submit"
                (click)="submitRegister()"
                [disabled]="registerForm.invalid"
                class="ibtn w-100"
              >
                SignUp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video.pause(); video.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
        >
          &times;
        </button>
      </div>

      <video
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />

        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>
